module.exports = flarum.core.compat['utils/abbreviateNumber'];